module.exports = __webpack_public_path__ + "static/media/defaultBg_small.a6165a1f.jpg";